import _defineProperty from "/Users/nick/Projects/lab3-website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../types.js').Handle} Handle
 * @typedef {import('../types.js').Exit} Exit
 */
import { formatHeadingAsSetext } from '../util/format-heading-as-setext.js';
import { containerPhrasing } from '../util/container-phrasing.js';
import { track } from '../util/track.js';
/**
 * @type {Handle}
 * @param {Heading} node
 */

export function heading(node, _, context, safeOptions) {
  var rank = Math.max(Math.min(6, node.depth || 1), 1);
  var tracker = track(safeOptions);

  if (formatHeadingAsSetext(node, context)) {
    var _exit = context.enter('headingSetext');

    var _subexit = context.enter('phrasing');

    var _value = containerPhrasing(node, context, _objectSpread(_objectSpread({}, tracker.current()), {}, {
      before: '\n',
      after: '\n'
    }));

    _subexit();

    _exit();

    return _value + '\n' + (rank === 1 ? '=' : '-').repeat( // The whole size…
    _value.length - ( // Minus the position of the character after the last EOL (or
    // 0 if there is none)…
    Math.max(_value.lastIndexOf('\r'), _value.lastIndexOf('\n')) + 1));
  }

  var sequence = '#'.repeat(rank);
  var exit = context.enter('headingAtx');
  var subexit = context.enter('phrasing'); // Note: for proper tracking, we should reset the output positions when there
  // is no content returned, because then the space is not output.
  // Practically, in that case, there is no content, so it doesn’t matter that
  // we’ve tracked one too many characters.

  tracker.move(sequence + ' ');
  var value = containerPhrasing(node, context, _objectSpread({
    before: '# ',
    after: '\n'
  }, tracker.current()));

  if (/^[\t ]/.test(value)) {
    // To do: what effect has the character reference on tracking?
    value = '&#x' + value.charCodeAt(0).toString(16).toUpperCase() + ';' + value.slice(1);
  }

  value = value ? sequence + ' ' + value : sequence;

  if (context.options.closeAtx) {
    value += ' ' + sequence;
  }

  subexit();
  exit();
  return value;
}